import { HKPImage } from "../../media/HKPImage";
import { KarkhanaProductionPanel } from "../karkhana/sarees/ProductionHistory";
import React, { useState, useEffect } from "react";
import { Label, Input, Button, Row, Col, FormGroup } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import QRCode from "react-qr-code";
import EntityIdentityBadge from "../physical-identity/EntityIdentityBadge";
import ReactChipInput from "react-chip-input";
import { Toggle } from "rsuite";

//components
import Loader from "../../common/Components/Loader/Loader";
import FilePreview from "./FilePreviewProduct";
import { baseImageCovert, baseImageCovertForLogoPin } from "./baseImageConver";
import { orderMediaByView } from "./steps/mediaViews";
import { filledOwnersFromProduct } from "./productOwnership";
import {
  getFlexibleFirstProcesses,
  isFlexibleProcessWorkflow,
  mapLegacyProcessFormFields,
} from "./productProcessMigrationUtils";
import { isSareeLikeProduct, productWeightLabel } from "./productSareeFields";
import { ProductInternalUseSection } from "./ProductInternalUseSection";
import Pin from "../../common/Components/Icons/Pin";
import Unpin from "../../common/Components/Icons/Unpin";

// actions
import { getProducts } from "../../Store/products/actions";
import EditIcon from "../../common/Components/Icons/EditIcon";
import DownloadIcon from "../../common/Components/Icons/DownloadIcon";
import FilePreviewPart from "./FilePreviewPart";
import ProcessMediaGrid, { remoteMediaUrls } from "./ProcessMediaGrid";
import ProcessGeoMap, { ProcessGeoLine } from "./ProcessGeoMap";
import { processGeoPins } from "./processGeo";
import RequestCapturePanel from "./RequestCapturePanel";
import ProductFamilyBar from "./ProductFamilyBar";
import { canCurrentUserUseProductCapture } from "../../helpers/productCaptureEnabled";
import { removeProductProcessMedia } from "../../services/productCaptureApi";
import notifications from "../../common/Components/Notifications/Notification";
import ShowIcon from "../../common/Components/Icons/ShowIcon";
import HideIcon from "../../common/Components/Icons/HideIcon";
import ViewEyeIcon from "../../common/Components/Icons/ViewEyeIcon";
import ProductImagePreView from "./ProductImagePreView";
import ProductMovementLog from "../sales/ProductMovementLog";
import { studioPieceQrUrl } from "../sales/internalQr";

const ViewProcessMediaLayout = ({
  artisanLabel,
  artisanValue,
  media,
  downloadName,
  productId,
  processTitle,
  processIndex,
  onDeleteMany,
}: {
  artisanLabel: string;
  artisanValue: any;
  media: any[];
  downloadName: string;
  productId?: string;
  processTitle: string;
  processIndex?: number;
  onDeleteMany?: (indexes: number[]) => void | boolean | Promise<void | boolean>;
}) => (
  <Row>
    <Col xs={12} lg={8}>
      <div className="formDiv">
        <Row>
          <Col xs={12} md={6}>
            <Label>{artisanLabel}</Label>
            <Input value={artisanValue || ""} readOnly />
          </Col>
        </Row>
      </div>
      <Label>Previewing files or images</Label>
      <ProcessMediaGrid items={media} downloadName={downloadName} onDeleteMany={onDeleteMany} />
      <ProcessGeoLine media={media} />
    </Col>
    <Col xs={12} lg={4}>
      <div className="hkp-process-step__aside">
        <RequestCapturePanel
          productId={productId}
          processTitle={processTitle}
          processIndex={processIndex}
        />
      </div>
    </Col>
  </Row>
);

const ViewProduct = (props: any) => {
  const location: any = useLocation();
  const ProductId: any = location?.pathname.split("/")[2];
  const ProductName: any = location?.state?.productDetails?.name;
  const [loading, setLoading]: any = useState(false);
  const [isOpen, setIsOpen]: any = useState(false);
  const [image, setImage]: any = useState("");
  const history = useHistory();
  const [form, setForm]: any = useState({
    productUniqueId: "",
    artform: "",
    type: "",
    category: "",
    subCategory: "",
    weaveType: "",
    productName: "",
    designer: "",
    designerMedia: [],
    weaver: "",
    weaverMedia: [],
    dyer: "",
    dyerMedia: [],
    finisher: "",
    finisherMedia: [],
    profileURL: "",
    tags: [],
    variants: [],
    yarnType: "",
    workingHours: "",
    loomNum: "",
    color: "",
    description: "",
    productOwner: "",
    sellPrice: "",
    costPrice: "",
    designNum: "",
    processWorkflowVersion: "",
    flexibleUploadProcesses: [],
  });
  useEffect(() => {
    if (ProductId) {
      getAllData();
    }
  }, [ProductId]);
  const getAllData = () => {
    setLoading(true);
    props.getProducts(
      {
        offset: 0,
        limit: 10,
        ProductId: ProductId,
        // ProductsName: ProductName,
      },
      (res: any) => {
        setLoading(false);
        if (res?.data?.docs?.length) {
          let editDetails: any = res?.data?.docs[0];
          let variantArry: any = [];
          let variantBaseDetails = {
            color: editDetails?.color,
            additionalImages: editDetails?.additionalImages?.length
              ? editDetails?.additionalImages
              : [],
          };
          variantArry.push(variantBaseDetails);
          const processFields = mapLegacyProcessFormFields(editDetails, baseImageCovert);
          const flexibleWorkflow = isFlexibleProcessWorkflow(editDetails);
          setForm({
            _id: editDetails?._id,
            org: editDetails?.organizations?.length
              ? editDetails?.organizations[0]?.name
              : "",
            ...filledOwnersFromProduct(editDetails),

            productUniqueId: editDetails?.productUniqueId,
            artform: editDetails?.artform?.name,
            type: editDetails?.type?.name,
            category: editDetails?.category?.name,
            subCategory: editDetails?.subcategory?.name,
            weaveType: editDetails?.weavetype?.name,
            productName: editDetails?.name,
            ...processFields,
            profileURL: editDetails?.thumbnailDetails?.media?.length
              ? baseImageCovertForLogoPin(orderMediaByView(editDetails?.thumbnailDetails?.media))
              : editDetails?.thumbnailDetails === null &&
                editDetails?.thumbnail?.length > 0
              ? baseImageCovertForLogoPin([
                  {
                    mediaURL: editDetails?.thumbnail,
                    show: "1",
                    pin: "1",
                  },
                ])
              : [],
            tags: editDetails?.tags ? editDetails?.tags : "",
            variants:
              editDetails?.varients?.length > 0
                ? [...variantArry, ...editDetails?.varients]
                : [...variantArry],
            //new
            nameOfBrand: editDetails?.brand,
            nameOfWeaver: editDetails?.weaver,
            handloomMark: editDetails?.handloom === "true" ? true : false,
            silkMark: editDetails?.silk === "true" ? true : false,
            zariUsed: { label: editDetails?.zari, value: editDetails?.purity },
            weightOfSaree: editDetails?.sareeWeight,
            weightOfZariUsed: editDetails?.zariWeight,
            purity: editDetails?.purity,
            madeInIndia: editDetails?.madeIn === "true" ? true : false,
            yarnType: editDetails?.yarnType,
            workingHours: editDetails?.workingHours,
            loomNum: editDetails?.loomNum,
            xuid: editDetails?.xuid,
            SrNo: editDetails?.srNo,
            orgSrNo: editDetails?.orgSrNo,
            parentId: editDetails?.parentId,
            weavingCenter: editDetails?.weavingCenter || form?.weavingCenter,
            typeOfSareeByDesign: editDetails?.typeOfSareeByDesign,
            productionTimeInMonths: editDetails?.productionTimeInMonths,
            color: editDetails?.color,
            description: editDetails?.description || "",
            sellPrice: editDetails?.sellPrice,
            costPrice: editDetails?.costPrice,
            designNum: editDetails?.designNum,
            processWorkflowVersion: flexibleWorkflow ? "flexible" : "legacy",
            flexibleUploadProcesses: flexibleWorkflow
              ? getFlexibleFirstProcesses(editDetails).map((process) => ({
                  ...process,
                  media: baseImageCovert(process.media),
                }))
              : [],
          });
        }
      }
    );
  };
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleSetImage = (image: any) => {
    setImage(image);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const dropMediaIndexes = (list: any[], indexes: number[]) => {
    const drop = new Set(indexes);
    return (list || []).filter((_: any, j: number) => !drop.has(j));
  };

  const deleteViewMedia = async (
    items: any[],
    indexes: number[],
    processTitle: string,
    processIndex: number,
    apply: () => void,
    productProcessId?: string
  ) => {
    const urls = remoteMediaUrls(items, indexes);
    const saved = String(form?.productUniqueId || form?._id || ProductId || "").trim();
    if (!saved || !urls.length) {
      notifications({
        title: "Error",
        message: "Select a saved photo or video to delete.",
        type: "danger",
      });
      return false;
    }
    const res: any = await removeProductProcessMedia({
      productId: saved,
      processTitle,
      processIndex,
      productProcessId,
      mediaUrls: urls,
    });
    if (!res?.success) {
      notifications({
        title: "Error",
        message:
          res?.message ||
          "Could not delete. Open Edit Product if this product still uses the old process layout.",
        type: "danger",
      });
      return false;
    }
    apply();
    notifications({
      title: "Success",
      message: "Selected photos and videos were removed.",
      type: "success",
    });
    return true;
  };

  const productQrUrl = () => studioPieceQrUrl(form?.productUniqueId || ProductId);

  const copyProductQrLink = async () => {
    const url = productQrUrl();
    if (!url) {
      return;
    }
    let ok = false;
    try {
      await navigator.clipboard.writeText(url);
      ok = true;
    } catch {
      try {
        const el = document.createElement("textarea");
        el.value = url;
        el.setAttribute("readonly", "");
        el.style.position = "fixed";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        ok = document.execCommand("copy");
        document.body.removeChild(el);
      } catch {
        ok = false;
      }
    }
    notifications({
      title: ok ? "Success" : "Error",
      message: ok ? "Product link copied." : "Could not copy the link.",
      type: ok ? "success" : "danger",
    });
  };

  return (
    <>
      {isOpen && (
        <ProductImagePreView
          {...props}
          openModal={isOpen}
          closeModal={closeModal}
          images={[image?.blobImage || image]}
        />
      )}
      {loading ? (
        <div className="LoaderDiv">
          <Loader />
        </div>
      ) : (
        <div className="createProduct">
          <div className="form">
            <div className="UserDetailsDiv">
              <div className="UserHeader">
                Product Details
                <span className="editBtn">
                  {canCurrentUserUseProductCapture() && form?._id ? (
                    <Button
                      type="button"
                      onClick={() =>
                        document
                          .getElementById("hkp-upload-process")
                          ?.scrollIntoView({ behavior: "smooth", block: "start" })
                      }
                    >
                      Request capture
                    </Button>
                  ) : null}
                  <Button
                    type="button"
                    onClick={() => {
                      history.push(`/edit-product/${form?.productUniqueId}`, {
                        productDetails: form,
                      });
                    }}
                  >
                    Edit Product Details
                  </Button>
                </span>
              </div>
              <ProductFamilyBar
                mode="view"
                parentId={form?.parentId}
                productUniqueId={form?.productUniqueId}
                orgSrNo={form?.orgSrNo}
                onChanged={getAllData}
              />
              <div className="userPd">
                <div className="ViewImageQrCode">
                  {/* <div className="imageDiv">
                    {form?.profileURL?.length ? (
                      <>
                        <HKPImage preset="PRODUCT_DETAIL"
                          legacyUrl={form?.profileURL}
                          alt="logo"
                          width="200px"
                          height="200px"
                        />
                        <DownloadIcon
                          {...props}
                          // i={i}
                          image={form?.profileURL}
                          name={form?.productName + " productlogo"}
                        />
                      </>
                    ) : (
                      <div>No Preview Available</div>
                    )}
                  </div> */}
                  <section className="hkp-view-box hkp-view-box--qr">
                  <div
                    style={{
                      height: "200px",
                      marginBottom: "15px",
                    }}
                  >
                    <button
                      type="button"
                      className="hkp-view-qr"
                      onClick={copyProductQrLink}
                      title="Copy product link"
                      aria-label="Copy product link"
                    >
                      <QRCode
                        size={256}
                        style={{ height: "200px" }}
                        value={productQrUrl()}
                        viewBox={`0 0 556 556`}
                        level="L"
                      />
                    </button>
                  </div>
                  <p className="hkp-view-qr__hint">Click the QR to copy the link</p>
                  <EntityIdentityBadge productUniqueId={form?.productUniqueId || ProductId} />
                  </section>
                  {/* Production (from the karkhana) has its own box, then movement. */}
                  <KarkhanaProductionPanel productUniqueId={form?.productUniqueId || ProductId} />
                  <section className="hkp-view-box">
                    <ProductMovementLog productUniqueId={form?.productUniqueId || ProductId} />
                  </section>
                </div>
                <div className="">
                  <div className="imageDiv1">
                    {form?.profileURL?.length > 0 ? (
                      <div className="d-flex">
                        <div className="PreviewDivPart">
                          {form?.profileURL?.length > 0 &&
                            form?.profileURL.map((item: any, i: any) => {
                              return (
                                <React.Fragment key={i}>
                                  <div className="ArryyIcon">
                                    <DownloadIcon
                                      {...props}
                                      i={i}
                                      item={item}
                                      name={form?.productName + " logo"}
                                    />
                                    {item?.show === true ? (
                                      <ShowIcon index={i} name="logo" />
                                    ) : (
                                      <HideIcon index={i} name="logo" />
                                    )}
                                    {item?.pin === false ? (
                                      <Pin index={i} name="view" />
                                    ) : (
                                      <Unpin index={i} name="view" />
                                    )}
                                    {/* <div className="viewIconForPreview">
                                      <ViewEyeIcon
                                        {...props}
                                        onClick={() => {
                                          handleOpen();
                                          setImage(item);
                                        }}
                                      />
                                    </div> */}
                                    <FilePreviewPart
                                      {...props}
                                      item={item}
                                      handleOpen={handleOpen}
                                      handleSetImage={handleSetImage}
                                    />
                                  </div>
                                </React.Fragment>
                              );
                            })}
                        </div>
                      </div>
                    ) : (
                      <div className="PreIm">
                        {" "}
                        No Preview Images or Files Available for logo
                      </div>
                    )}
                  </div>
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label> SrNo</Label>
                      <Input name="orgSrNo" value={form?.orgSrNo} readOnly />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label> HKPtagNo</Label>
                      <Input name="SrNo" value={form?.SrNo} readOnly />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Artform</Label>
                      <Input
                        name="artform"
                        id="artform"
                        value={form?.artform}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Type</Label>
                      <Input
                        name="type"
                        id="type"
                        value={form?.type}
                        readOnly
                      />
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>Category</Label>
                      <Input
                        name="Category"
                        id="Category"
                        value={form?.category}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Sub-Category</Label>
                      <Input
                        name="subCategory"
                        id="subCategory"
                        value={form?.subCategory}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Weave Type</Label>
                      <Input
                        name="weaveType"
                        id="weaveType"
                        value={form?.weaveType}
                        readOnly
                      />
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    {isSareeLikeProduct(form) ? (
                    <Col xs={12} md={4}>
                      <Label>Types of sarees by design</Label>
                      <Input
                        className="form-control"
                        placeholder="Types of sarees by design"
                        value={form?.typeOfSareeByDesign}
                        readOnly
                      />
                    </Col>
                    ) : null}
                    <Col xs={12} md={4}>
                      <Label>Product</Label>
                      <Input
                        name="productName"
                        id="productName"
                        className="form-control"
                        placeholder="productName"
                        value={form?.productName}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Color of product</Label>
                      <Input
                        name="color"
                        id="color"
                        className="form-control"
                        placeholder="Color of product"
                        value={form?.color}
                        readOnly
                      />
                    </Col>
                    {form?.description ? (
                      <Col xs={12}>
                        <Label htmlFor="productDescription">Description</Label>
                        <Input
                          type="textarea"
                          id="productDescription"
                          className="form-control"
                          rows={4}
                          value={form.description}
                          readOnly
                        />
                      </Col>
                    ) : null}
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>Weaving Center</Label>
                      <Input
                        className="form-control"
                        placeholder="Weaving Center"
                        value={form?.weavingCenter}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Add Tags</Label>
                      <ReactChipInput
                        {...props}
                        classes="class1 class2"
                        chips={form.tags}
                        disabled={true}
                        onSubmit={(value: any) => {}}
                        onRemove={(index: any) => {}}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Name of Brand</Label>
                      <Input
                        name="nameOfBrand"
                        id="nameOfBrand"
                        className="form-control"
                        placeholder="Name Of Brand"
                        value={form?.nameOfBrand}
                        readOnly
                      />
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>Name of weaver</Label>
                      <Input
                        name="nameOfWeaver"
                        id="nameOfWeaver"
                        className="form-control"
                        placeholder="Name Of Weaver"
                        value={form?.nameOfWeaver}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Zari Used</Label>
                      <div className="formDivSub">
                        <Input
                          className="form-control"
                          placeholder="Zari Used"
                          value={form?.zariUsed?.label}
                          readOnly
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>{productWeightLabel(form)}</Label>
                      <Input
                        name="weightOfSaree"
                        id="weightOfSaree"
                        className="form-control"
                        placeholder="Weight Of Saree"
                        value={form?.weightOfSaree}
                        readOnly
                      />
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>Weight of Zari used</Label>
                      <Input
                        type="text"
                        name="weightOfZariUsed"
                        id="weightOfZariUsed"
                        className="form-control"
                        placeholder="Weight of Zari used"
                        value={form?.weightOfZariUsed}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Purity of Zari</Label>
                      <Input
                        type="textarea"
                        name="purityOfZari"
                        id="purityOfZari"
                        className="form-control"
                        placeholder="Purity Of Zari"
                        value={form?.zariUsed?.value}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Yarn type </Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Yarn type"
                        value={form?.yarnType}
                        readOnly
                      />
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>Time Taken in months </Label>
                      <Input
                        className="form-control"
                        placeholder="Time Taken in months"
                        value={form?.productionTimeInMonths}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Working Hours </Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Working Hours"
                        value={form?.workingHours}
                        readOnly
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Label>Loom Number </Label>
                      <Input
                        className="form-control"
                        placeholder="Loom Number"
                        value={form?.loomNum}
                        readOnly
                      />
                    </Col>
                  </Row>
                  </div>
                  <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>Design Number</Label>
                      <Input
                        className="form-control"
                        placeholder="Design Number"
                        value={form?.designNum}
                        readOnly
                      />
                    </Col>
                  </Row>
                </div>
                <div className="formDiv">
                  <Row>
                    <Col xs={12} md={4}>
                      <Label>HKP ID </Label>
                      <Input
                        className="form-control"
                        placeholder="HKP ID"
                        value={form?.xuid}
                        readOnly
                      />
                    </Col>
                  </Row>
                </div>
                <div className="formDiv hkp-product-flags">
                  <Row>
                    <Col xs={6} md={4}>
                      <Label>Silk Mark</Label>
                      <FormGroup className="mb-0">
                        <Toggle
                          size="lg"
                          checked={form?.silkMark}
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={6} md={4}>
                      <Label>Handloom Mark</Label>
                      <FormGroup className="mb-0">
                        <Toggle
                          size="lg"
                          checked={form?.handloomMark}
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={6} md={4}>
                      <Label>Made in India</Label>
                      <FormGroup className="mb-0">
                        <Toggle
                          size="lg"
                          checked={form?.madeInIndia}
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
                <ProductInternalUseSection
                  sellPrice={form?.sellPrice}
                  costPrice={form?.costPrice}
                  productUniqueId={form?.productUniqueId || ProductId}
                  readOnly
                />
              </div>
            </div>
            {isFlexibleProcessWorkflow(form) ? (
              <div className="UserDetailsDiv mb-5" id="hkp-upload-process">
                <div className="UserHeader headerDisplay">
                  <div>Upload Process</div>
                </div>
                <div className="userPd">
                  {form?.flexibleUploadProcesses?.length > 0 ? (
                    form.flexibleUploadProcesses.map((process: any, index: number) => (
                      <div key={process?.productProcessId || process?.key || index} className="mb-4">
                        <div className="UserHeader headerDisplay">
                          <div>{process?.title || `Process ${index + 1}`}</div>
                        </div>
                        <Row>
                          <Col xs={12} lg={8}>
                            {process?.subtitle ? (
                              <p className="text-muted small mb-2">{process.subtitle}</p>
                            ) : null}
                            {process?.text ? (
                              <p className="mb-2" style={{ whiteSpace: "pre-wrap" }}>
                                {process.text}
                              </p>
                            ) : null}
                            <Row>
                              <Col xs={12} md={6}>
                                <Label>Artisan</Label>
                                <Input value={process?.karigar?.name || ""} readOnly />
                              </Col>
                            </Row>
                            <Label>Previewing files or images</Label>
                            <ProcessMediaGrid
                              items={process?.media}
                              downloadName={`${form?.productName} ${process?.title || "process"}`}
                              onDeleteMany={(indexes) =>
                                deleteViewMedia(
                                  process?.media,
                                  indexes,
                                  process?.title || "",
                                  index,
                                  () => {
                                    setForm((f: any) => ({
                                      ...f,
                                      flexibleUploadProcesses: (f.flexibleUploadProcesses || []).map(
                                        (p: any, i: number) =>
                                          i === index
                                            ? { ...p, media: dropMediaIndexes(p.media, indexes) }
                                            : p
                                      ),
                                    }));
                                  },
                                  process?.productProcessId
                                )
                              }
                            />
                            <ProcessGeoLine media={process?.media} />
                          </Col>
                          <Col xs={12} lg={4}>
                            <div className="hkp-process-step__aside">
                              <RequestCapturePanel
                                key={process?.productProcessId || process?.key || index}
                                productId={form?.productUniqueId || form?._id}
                                processTitle={process?.title || ""}
                                processIndex={index}
                                productProcessId={process?.productProcessId}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    ))
                  ) : (
                    <div className="PreIm">No upload process available</div>
                  )}
                  <ProcessGeoMap
                    pins={processGeoPins(
                      (form?.flexibleUploadProcesses || []).map((process: any) => ({
                        title: process?.title,
                        media: process?.media,
                      }))
                    )}
                  />
                </div>
              </div>
            ) : (
            <div className="UserDetailsDiv mb-5" id="hkp-upload-process">
              <div className="UserHeader headerDisplay">
                <div>Designing</div>
              </div>
              <div className="userPd">
                <ViewProcessMediaLayout
                  artisanLabel="Artisan"
                  artisanValue={form?.designer}
                  media={form?.designerMedia}
                  downloadName={`${form?.productName || ""} designing`}
                  productId={form?.productUniqueId || form?._id}
                  processTitle="Designing"
                  processIndex={0}
                  onDeleteMany={(indexes) =>
                    deleteViewMedia(form?.designerMedia, indexes, "Designing", 0, () => {
                      setForm((f: any) => ({
                        ...f,
                        designerMedia: dropMediaIndexes(f.designerMedia, indexes),
                      }));
                    })
                  }
                />
              </div>
              <div className="UserHeader headerDisplay">
                <div>Dying</div>
              </div>
              <div className="userPd">
                <ViewProcessMediaLayout
                  artisanLabel="Karigar"
                  artisanValue={form?.dyer}
                  media={form?.dyerMedia}
                  downloadName={`${form?.productName || ""} dying`}
                  productId={form?.productUniqueId || form?._id}
                  processTitle="Dying"
                  processIndex={2}
                  onDeleteMany={(indexes) =>
                    deleteViewMedia(form?.dyerMedia, indexes, "Dying", 2, () => {
                      setForm((f: any) => ({
                        ...f,
                        dyerMedia: dropMediaIndexes(f.dyerMedia, indexes),
                      }));
                    })
                  }
                />
              </div>

              <div className="UserHeader headerDisplay">
                <div>Weaving</div>
              </div>
              <div className="userPd">
                <ViewProcessMediaLayout
                  artisanLabel="Karigar"
                  artisanValue={form?.weaver}
                  media={form?.weaverMedia}
                  downloadName={`${form?.productName || ""} weaving`}
                  productId={form?.productUniqueId || form?._id}
                  processTitle="Weaving"
                  processIndex={1}
                  onDeleteMany={(indexes) =>
                    deleteViewMedia(form?.weaverMedia, indexes, "Weaving", 1, () => {
                      setForm((f: any) => ({
                        ...f,
                        weaverMedia: dropMediaIndexes(f.weaverMedia, indexes),
                      }));
                    })
                  }
                />
              </div>

              <div className="UserHeader headerDisplay">
                <div>Finishing</div>
              </div>
              <div className="userPd">
                <ViewProcessMediaLayout
                  artisanLabel="Karigar"
                  artisanValue={form?.finisher}
                  media={form?.finisherMedia}
                  downloadName={`${form?.productName || ""} finishing`}
                  productId={form?.productUniqueId || form?._id}
                  processTitle="Finishing"
                  processIndex={3}
                  onDeleteMany={(indexes) =>
                    deleteViewMedia(form?.finisherMedia, indexes, "Finishing", 3, () => {
                      setForm((f: any) => ({
                        ...f,
                        finisherMedia: dropMediaIndexes(f.finisherMedia, indexes),
                      }));
                    })
                  }
                />
              </div>
              <div className="userPd">
                <ProcessGeoMap
                  pins={processGeoPins([
                    { title: "Designing", media: form?.designerMedia },
                    { title: "Dying", media: form?.dyerMedia },
                    { title: "Weaving", media: form?.weaverMedia },
                    { title: "Finishing", media: form?.finisherMedia },
                  ])}
                />
              </div>
            </div>
            )}
              <div className="UserDetailsDiv mb-5">
                <div className="UserHeader headerDisplay">
                  <div>Variants</div>
                </div>
                <div className="userPd">
                  {form?.variants?.length > 0 ? (
                    form?.variants.map((ele: any, i: any) => (
                      <React.Fragment key={i}>
                        <div className="formDiv12">
                          Color:<span>{ele.color}</span>
                        </div>
                        <Label>Previewing images or files</Label>

                        <div className="">
                          <div className="imageDiv1">
                            <div className="d-flex">
                              <div className="PreviewDivPart">
                                {ele?.additionalImages?.length > 0 &&
                                  ele?.additionalImages.map(
                                    (item: any, i: any) => {
                                      return (
                                        <React.Fragment key={i}>
                                          <div className="ArryyIcon">
                                            <DownloadIcon
                                              {...props}
                                              // i={i}
                                              image={item}
                                              name={
                                                form?.productName + " variant"
                                              }
                                              placePosition={"first"}
                                            />
                                            <div
                                              onClick={() => {
                                                handleOpen();
                                                handleSetImage(item);
                                              }}
                                            >
                                              <FilePreview
                                                fileUrl={item}
                                                height={200}
                                                width={180}
                                              />
                                            </div>
                                          </div>
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <div className="PreIm">
                      {" "}
                      No Preview Images or Files Available for Designing
                    </div>
                  )}
                </div>
              </div>
            </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, {
  getProducts,
})(ViewProduct);

